// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchField_switch__2xYQ7"};